module.exports = __webpack_public_path__ + "img/H3.59343069.png";